import { getSessionInstructor } from "@kvix/shared";
import { Avatar, Box, IconButton, makeStyles } from "@material-ui/core";
import { motion } from "framer-motion";
import React from "react";
import { Link } from "react-router-dom";
import { SessionInfo, SessionPreviewImage } from "..";
import { KvixIcon } from "../../icons";
const useStyles = makeStyles((theme) => ({
    sessionItem: {
        display: "flex",
        flexDirection: "column",
        cursor: "pointer",
        width: "280px"
    },
    playWrapper: {
        height: "40px",
        width: "40px",
        position: "absolute",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        background: "white",
        left: "calc(50% - 22px)",
        top: "75px",
        "&:before": {
            content: "''",
            height: "0",
            width: "0",
            display: "block",
            borderTop: "7px solid transparent",
            borderBottom: "7px solid transparent",
            borderLeft: `10px solid ${theme.palette.primary.main}`,
            position: "inherit",
            top: "calc(50% - 7px)",
            left: "calc(50% - 4px)"
        }
    },
    avatar: {
        height: "72px",
        width: "72px",
        marginRight: "15px"
    },
    favouriteButton: {
        position: "absolute",
        top: 165,
        right: 0,
        color: theme.palette.primary.main,
        textTransform: "initial",
        background: "transparent",
        width: "28px",
        height: "28px",
        boxShadow: "none",
        transition: "transform 200ms ease-in-out",
        "&:hover": {
            transform: "scale(1.1)",
            background: "transparent"
        },
        "&:focus": {
            boxShadow: "none"
        }
    },
    heartIcon: {
        marginTop: "2px",
        fontSize: 22,
        zIndex: 1
    }
}));
export const SessionSwiperItem = ({ session, toggleFavourite, isLiked }) => {
    const classes = useStyles();
    const instructor = getSessionInstructor(session);
    return (React.createElement(motion.div, { className: classes.sessionItem, animate: "off", initial: false, whileHover: "on", whileTap: "on" },
        toggleFavourite && (React.createElement(IconButton, { className: classes.favouriteButton, size: "small", disableRipple: true, disableTouchRipple: true, disableFocusRipple: true, TouchRippleProps: {}, onClickCapture: (e) => {
                e.preventDefault();
                toggleFavourite();
            } }, isLiked ? (React.createElement(KvixIcon.Heart.Filled, { className: classes.heartIcon })) : (React.createElement(KvixIcon.Heart.Empty, { className: classes.heartIcon })))),
        React.createElement(Link, { to: `/replay/${session === null || session === void 0 ? void 0 : session.id}` },
            React.createElement(Box, { height: "155px", borderRadius: "4px" },
                React.createElement(SessionPreviewImage, { session: session }),
                React.createElement(motion.div, { className: classes.playWrapper, variants: {
                        off: { opacity: 0, translateY: "0px" },
                        on: { opacity: 1, translateY: "-20px" }
                    }, transition: { ease: "easeInOut", duration: 0.35 } })),
            React.createElement(Box, { display: "flex", paddingTop: "15px" },
                React.createElement(Avatar, { className: classes.avatar, src: instructor === null || instructor === void 0 ? void 0 : instructor.imageUrl }),
                React.createElement(SessionInfo, { session: session, showChannel: false })))));
};
//# sourceMappingURL=SessionSwiperItem.js.map